import {getCssSizeValue, getHtmlFromRedactorField, isStringEmpty} from "@/utils/utils";
import LinkButton from "@/components/common/Buttons/LinkButton";
import {BUTTON_VARIANTS} from "@/constants";
import React from "react";
import {BREAKPOINTS} from "@/styles/themeSettings";
import GridContainer from "@/components/common/GridContainer";
import styled from "styled-components";
import {getButtonLinkData} from "@/components/common/Buttons/Button";

export const HEADER_DESCRIPTION_WITH_BUTTON_VARIANT = {
	DARK: 'dark',
	LIGHT: 'light'
}

const StyledWrapper = styled.div`
	--bgColor: ${({theme}) => theme.colors.white};
    --textColor: ${({theme}) => theme.colors.richBlack};
    background: var(--bgColor);
    color: var(--textColor);

    &.variant-${HEADER_DESCRIPTION_WITH_BUTTON_VARIANT.DARK} {
        --bgColor: ${({theme}) => theme.colors.richBlue};
        --textColor: ${({theme}) => theme.colors.antiflashWhite};
    }
`

const StyledColumn = styled.div`
    display: flex;
    flex-direction: column;

    &.first {
        gap: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};
        margin-bottom: ${getCssSizeValue(32, BREAKPOINTS.MOBILE)};

        @media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
            gap: ${getCssSizeValue(32, BREAKPOINTS.TABLET)};
            margin-bottom: ${getCssSizeValue(24, BREAKPOINTS.TABLET)};
        }

        @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
            gap: ${getCssSizeValue(32)};
            translate: 0 ${getCssSizeValue(10)};
            margin: unset;
        }
    }

    &.second {
        gap: ${getCssSizeValue(32, BREAKPOINTS.MOBILE)};
		
        @media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
            align-items: end;
            gap: ${getCssSizeValue(32, BREAKPOINTS.TABLET)};
        }

        @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
            gap: ${getCssSizeValue(32)};
            align-items: end;
        }
    }
`

export default function HeaderDescriptionWithButton({
	header,
	description,
	button,
	variant = HEADER_DESCRIPTION_WITH_BUTTON_VARIANT.LIGHT,
	paddingTop = ''
}) {
	const buttonLinkData = getButtonLinkData(button)

	return (
		<StyledWrapper className={`variant-${variant} ${paddingTop}`}>
			<GridContainer>
				<StyledColumn className='col-mobile-8 col-tablet-6 col-desktop-9 first'>
					<div
						className='typo-borna typo-borna-36 col-desktop-3 col-tablet-3 col-mobile-4'>{header}</div>
					<div
						dangerouslySetInnerHTML={getHtmlFromRedactorField(description)}
						className='typo-strawford typo-strawford-38 col-desktop-7 col-tablet-4 col-mobile-8'
					/>
				</StyledColumn>

				<StyledColumn className='col-mobile-8 col-tablet-7 col-desktop-7 second'>
					{/*<div*/}
					{/*	dangerouslySetInnerHTML={getHtmlFromRedactorField(rightText)}*/}
					{/*	className='typo-strawford typo-strawford-38 col-desktop-7 col-tablet-4 col-mobile-8'*/}
					{/*/>*/}
					{!isStringEmpty(buttonLinkData.url) && (
						<LinkButton {...buttonLinkData} variant={BUTTON_VARIANTS.TERTIARY}/>
					)}
				</StyledColumn>
			</GridContainer>
		</StyledWrapper>
	)
}